(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["francalanci-footer"] && !Shopify.designMode) return;
  try {
    
class FrancalanciFooter extends HTMLElement {
  connectedCallback() {
    if (this.dataset.newsletterBound === 'true') return;
    this.dataset.newsletterBound = 'true';

    const toggle = this.querySelector('[data-footer-newsletter-toggle]');
    const panel = this.querySelector('[data-footer-newsletter-form]');
    const input = panel?.querySelector('input[type="email"]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      panel.hidden = false;
      toggle.hidden = true;
      input?.focus();
    });
  }
}

if (!customElements.get('francalanci-footer')) {
  customElements.define('francalanci-footer', FrancalanciFooter);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  const IRIS_MS = 800;
  const LEAD_MS = 1500;
  const MAX_VIDEO_LOAD_ATTEMPTS = 2;

  function normalizePath(pathname) {
    if (!pathname || pathname === '/') return '/';
    return pathname.replace(/\/+$/, '') || '/';
  }

  function sameSiteReferrer() {
    try {
      if (!document.referrer) return '';
      const previous = new URL(document.referrer);
      const herePath = normalizePath(window.location.pathname);
      const previousPath = normalizePath(previous.pathname);
      if (previous.origin === window.location.origin && previousPath !== herePath) {
        return document.referrer;
      }
    } catch (error) {
      void error;
    }
    return '';
  }

  function leavePage(root) {
    const home = root.getAttribute('data-home-url') || '/';
    const previousOnSite = sameSiteReferrer();

    if (window.history.length > 1) {
      let left = false;
      window.addEventListener('pagehide', function () {
        left = true;
      });
      window.history.back();
      window.setTimeout(function () {
        if (left) return;
        window.location.assign(previousOnSite || home);
      }, 700);
      return;
    }

    window.location.assign(previousOnSite || home);
  }

  function isNarrowViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  }

  function isMobileDevice() {
    return window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function loadVimeoAPI() {
    return new Promise(function (resolve, reject) {
      if (window.Vimeo && window.Vimeo.Player) {
        resolve();
        return;
      }

      const existing = document.querySelector('script[src="https://player.vimeo.com/api/player.js"]');
      if (existing) {
        const startedAt = Date.now();
        const poll = window.setInterval(function () {
          if (window.Vimeo && window.Vimeo.Player) {
            window.clearInterval(poll);
            resolve();
          } else if (Date.now() - startedAt > 8000) {
            window.clearInterval(poll);
            reject(new Error('Timed out waiting for Vimeo API'));
          }
        }, 50);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.async = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Failed to load Vimeo API'));
      };
      document.head.appendChild(script);
    });
  }

  function videoIdFor(root) {
    const desktopId = root.getAttribute('data-desktop-video') || '';
    const mobileId = root.getAttribute('data-mobile-video') || '';
    if (isNarrowViewport() && isMobileDevice() && mobileId) return mobileId;
    return desktopId;
  }

  function updateMuteButton(muteButton, muted) {
    if (!muteButton) return;
    muteButton.setAttribute('data-muted', muted ? 'true' : 'false');
    muteButton.setAttribute('aria-pressed', muted ? 'true' : 'false');
  }

  function lockVideoDimensions(container) {
    if (!container || !isNarrowViewport()) return;

    const lock = function () {
      const ua = navigator.userAgent || '';
      const isIPhoneChrome = /iPhone/i.test(ua) && /CriOS/i.test(ua);
      const viewport = window.visualViewport;
      const viewportW = (viewport && viewport.width) || window.innerWidth;
      const viewportH = (viewport && viewport.height) || window.innerHeight;
      const isPortrait = viewportH > viewportW;
      const screenLong = Math.max(viewportW, viewportH);
      const screenShort = Math.min(viewportW, viewportH);
      let transform = '';
      let width = 0;
      let height = 0;

      if (isPortrait) {
        const overscan = isIPhoneChrome ? 1.16 : 1.1;
        width = screenLong * overscan;
        height = screenShort * overscan;
        transform = 'translate(-50%, -50%) rotate(90deg)';
      } else {
        const overscan = isIPhoneChrome ? 1.1 : 1.05;
        width = viewportW * overscan;
        height = viewportH * overscan;
        transform = 'translate(-50%, -50%) rotate(0deg)';
      }

      container.style.setProperty('inset', 'unset', 'important');
      container.style.setProperty('width', width + 'px', 'important');
      container.style.setProperty('height', height + 'px', 'important');
      container.style.setProperty('position', 'fixed', 'important');
      container.style.setProperty('top', '50%', 'important');
      container.style.setProperty('left', '50%', 'important');
      container.style.setProperty('right', 'auto', 'important');
      container.style.setProperty('bottom', 'auto', 'important');
      container.style.setProperty('transform', transform, 'important');
      container.style.setProperty('transform-origin', 'center center', 'important');

      const inner = container.querySelector('iframe, div');
      if (!inner) return;

      let scale = 1.15;
      if (isPortrait) {
        scale = Math.max(viewportH / height, viewportW / width) * (isIPhoneChrome ? 1.4 : 1.25);
      } else {
        scale = Math.max(viewportW / width, viewportH / height) * (isIPhoneChrome ? 1.52 : 1.38);
      }

      inner.style.setProperty('width', '100%', 'important');
      inner.style.setProperty('height', '100%', 'important');
      inner.style.setProperty('position', 'absolute', 'important');
      inner.style.setProperty('top', '50%', 'important');
      inner.style.setProperty('left', '50%', 'important');
      inner.style.setProperty('transform', 'translate(-50%, -50%) scale(' + scale + ')', 'important');
      inner.style.setProperty('transform-origin', 'center center', 'important');
      inner.style.setProperty('object-fit', 'cover', 'important');
    };

    lock();
    window.addEventListener('resize', lock);
    window.addEventListener('orientationchange', lock);
    window.setTimeout(lock, 500);
  }

  function init(root) {
    if (!root || root.dataset.introReady === 'true') return;
    root.dataset.introReady = 'true';
    root.querySelectorAll(':scope > iframe').forEach(function (frame) {
      frame.remove();
    });

    const container = root.querySelector('[data-vimeo-container]');
    const skipButton = root.querySelector('[data-intro-skip]');
    const muteButton = root.querySelector('[data-intro-mute]');
    const state = {
      player: null,
      muted: true,
      closing: false,
      attempts: 0,
    };

    function closeAndLeave(delay) {
      if (state.closing) return;
      state.closing = true;
      if (container) container.classList.add('animate-iris-out');
      window.setTimeout(function () {
        if (state.player) {
          state.player.unload().catch(function () {});
          state.player.destroy().catch(function () {});
          state.player = null;
        }
        leavePage(root);
      }, delay);
    }

    function toggleMute(event) {
      if (event) event.stopPropagation();
      if (!state.player) return;
      state.player
        .getMuted()
        .then(function (currentMuted) {
          const next = !currentMuted;
          const change = next ? state.player.setMuted(true) : state.player.setMuted(false).then(function () {
            return state.player.setVolume(1);
          });
          return change.then(function () {
            state.muted = next;
            updateMuteButton(muteButton, state.muted);
          });
        })
        .catch(function () {});
    }

    if (skipButton) {
      skipButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeAndLeave(IRIS_MS);
      });
    }

    if (muteButton) {
      muteButton.addEventListener('click', toggleMute);
    }

    function attachUnlock() {
      const events = ['pointerdown', 'touchstart', 'click', 'keydown'];
      function unlock(event) {
        if (muteButton && event.target && muteButton.contains(event.target)) return;
        if (skipButton && event.target && skipButton.contains(event.target)) return;
        if (state.player && state.muted) {
          state.player
            .setMuted(false)
            .then(function () {
              return state.player.setVolume(1);
            })
            .then(function () {
              state.muted = false;
              updateMuteButton(muteButton, false);
            })
            .catch(function () {});
        }
        detach();
      }
      function detach() {
        events.forEach(function (name) {
          window.removeEventListener(name, unlock, true);
        });
      }
      events.forEach(function (name) {
        window.addEventListener(name, unlock, { capture: true, passive: true });
      });
    }

    function removeAutoEmbeds() {
      root.querySelectorAll(':scope > iframe').forEach(function (frame) {
        frame.remove();
      });
    }

    function coverStage() {
      removeAutoEmbeds();
      if (!container || isNarrowViewport()) return;
      const nodes = container.querySelectorAll('iframe, div');
      nodes.forEach(function (node) {
        node.style.setProperty('position', 'absolute', 'important');
        node.style.setProperty('top', '50%', 'important');
        node.style.setProperty('left', '50%', 'important');
        node.style.setProperty('width', '100vw', 'important');
        node.style.setProperty('height', '100dvh', 'important');
        node.style.setProperty('max-width', 'none', 'important');
        node.style.setProperty('max-height', 'none', 'important');
        node.style.setProperty('transform', 'translate(-50%, -50%) scale(1.25)', 'important');
        node.style.setProperty('transform-origin', 'center center', 'important');
      });
    }

    function startPlayer() {
      if (state.attempts >= MAX_VIDEO_LOAD_ATTEMPTS) {
        closeAndLeave(0);
        return;
      }
      state.attempts += 1;

      if (!window.Vimeo || !window.Vimeo.Player) {
        window.setTimeout(startPlayer, 500);
        return;
      }

      const videoId = videoIdFor(root);
      if (!videoId) {
        closeAndLeave(0);
        return;
      }

      const mobile = isMobileDevice();
      state.muted = true;
      updateMuteButton(muteButton, true);

      try {
        state.player = new window.Vimeo.Player(container, {
          id: videoId,
          width: Math.round(window.innerWidth),
          height: Math.round(window.innerHeight),
          autoplay: true,
          muted: true,
          controls: false,
          loop: false,
          autopause: false,
          byline: false,
          title: false,
          portrait: false,
          dnt: true,
          playsinline: true,
          responsive: false,
          background: mobile,
        });
      } catch (error) {
        void error;
        window.setTimeout(startPlayer, 1000);
        return;
      }

      if (!mobile && !isNarrowViewport()) {
        container.style.setProperty('width', '100vw', 'important');
        container.style.setProperty('height', '100dvh', 'important');
        container.style.setProperty('position', 'absolute', 'important');
        container.style.setProperty('inset', '0', 'important');
        coverStage();
        window.setTimeout(coverStage, 100);
        window.setTimeout(coverStage, 600);
      }

      state.player.on('loaded', function () {
        coverStage();
        state.player.setMuted(true).then(function () {
          return state.player.play();
        }).catch(function () {});

        state.player.getDuration().then(function (duration) {
          if (!duration || duration <= 0) return;
          const fireAt = Math.max(0, duration * 1000 - LEAD_MS);
          window.setTimeout(function () {
            if (state.closing || !state.player) return;
            state.player.getPaused().then(function (paused) {
              if (!paused) closeAndLeave(IRIS_MS);
            }).catch(function () {
              closeAndLeave(IRIS_MS);
            });
          }, fireAt);
        }).catch(function () {});
      });

      state.player.on('ended', function () {
        closeAndLeave(0);
      });

      attachUnlock();
    }

    window.requestAnimationFrame(function () {
      lockVideoDimensions(container);
      loadVimeoAPI().then(function () {
        window.setTimeout(startPlayer, /iPhone|iPad|iPod/i.test(navigator.userAgent) ? 300 : 200);
      }).catch(function () {
        closeAndLeave(0);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-intro-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target && event.target.querySelector ? event.target.querySelector('[data-intro-video]') : null;
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
